import React from 'react';
import logo from './logo.svg';
import './App.css';

// import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import FAQs from './FAQ.yaml';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function App() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Here are the questions we commonly get asked, along with an answer for each!
        </p>
        {/* <pre>{FAQs.FAQs[0].heading}</pre> */}
        <a
          className="App-link"
          href="https://pawflix.net"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit PawFlix
        </a>
      </header>
      <main className="App-main">
        <Container>
          {FAQs.FAQs.map((faq, i) =>
            <Accordion expanded={expanded === 'panel'+i} onChange={handleChange('panel'+i)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={"panel"+i+"bh-content"}
                id={"panel"+i+"bh-header"}
              >
                <Typography className={classes.heading}>{faq.heading}</Typography>
                <Typography className={classes.secondaryHeading}>{faq.secondary}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography style={{textAlign: 'left'}}>
                  <span dangerouslySetInnerHTML={{ __html: faq.body }}/>
                </Typography>
              </AccordionDetails>
            </Accordion>
          )}
        </Container>
      </main>
    </div>
  );
}

export default App;
